
import { useEffect, useRef, useState } from 'react';
import ProductCard from '../../../components/base/ProductCard';
import { products } from '../../../mocks/products';

export default function ProductGrid() {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const sectionRef = useRef<HTMLDivElement>(null);

  const categories = ['All', 'Tops', 'Bottoms', 'Dresses', 'Outerwear', 'Bag', 'Accessory'];

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="bg-white">
      {/* All Products Section */}
      <section 
        ref={sectionRef}
        id="shop"
        className="py-20 px-6 md:px-12"
      >
        <div className="max-w-7xl mx-auto">
          <div 
            className={`transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div className="text-center mb-16">
              <div className="inline-block relative">
                <h2 className="text-3xl md:text-4xl font-light text-gray-900 tracking-[0.2em] mb-4">
                  COLLECTIONS
                </h2>
                <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-12 h-0.5 bg-black"></div>
              </div>
            </div>
            
            {/* Category Filter */}
            <div className="flex flex-wrap justify-center gap-4 mb-16">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 text-xs font-medium tracking-[0.2em] transition-all duration-300 border ${
                    selectedCategory === category
                      ? 'bg-black text-white border-black'
                      : 'bg-transparent text-gray-700 border-gray-300 hover:border-black hover:text-black'
                  }`}
                >
                  {category.toUpperCase()}
                </button>
              ))}
            </div>
            
            {/* Product Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
              {filteredProducts.map((product, index) => (
                <div
                  key={product.id}
                  className={`transition-all duration-1000 ease-out ${
                    isVisible 
                      ? 'opacity-100 translate-y-0' 
                      : 'opacity-0 translate-y-12'
                  }`}
                  style={{ transitionDelay: `${100 + index * 50}ms` }}
                >
                  <ProductCard {...product} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
